/* eslint-disable @typescript-eslint/no-explicit-any */
declare const gtag: any;

// Define a type for GA event objects
interface GtagEvent {
    name: string;
    category: string;
}

import versionOpen from "./events/version/versionOpen";
import versionClose from "./events/version/versionClose";
import exportButtonClick from "./events/export/exportButtonClick";
import exportJsonSuccessful from "./events/export/exportJsonSuccessful";
import exportJsonFailed from "./events/export/exportJsonFailed";
import scrapeSuccessful from "./events/scrape/scrapeSuccessful";
import scrapeFailed from "./events/scrape/scrapeFailed";
import urlSearchHistorySelected from "./events/urlsearch/urlSearchHistorySelected";
import sitemapSkipped from "./events/sitemap/skipped";
import sitemapNotFound from "./events/sitemap/notFound";
import sitemapFailed from "./events/sitemap/failed";
import sitemapGenerate from "./events/sitemap/generate";
import settingDebug from "./events/settings/settingsDebug";
import settingSitemapToggle from "./events/settings/settingsSitemap";
import settingStorageClear from "./events/settings/storageClear";
import { useActiveUrlStore } from '@/store/activeUrlStore';

export class GoogleAnalytics {
    public static reportEvent(event: GtagEvent, value: number = 1): void {   
        
        console.log('reportEvent', event, value);
      gtag('event', event.name, {
            event_category: event.category,
            event_label: document.location.host,
            value: value
        });
    }
    /**
     * Report the version popup open
     */
    public static versionOpen(): void {
        versionOpen();
    }
    /**
     * Report the version popup close
     */
    public static versionClose(): void {
        versionClose();
    }
    /**
     * Report export button click
     */
    public static exportButtonClick(): void {
        exportButtonClick();
    }
    /**
     * Report successful JSON export
     */
    public static exportJsonSuccessful(): void {
        exportJsonSuccessful();
    }
    /**
     * Report successful JSON export
     */
    public static exportJsonFailed(): void {
        exportJsonFailed();
    }
    /**
     * Report successful scrape by provider when all urls have been fetched
     */
    public static scrapeSuccessful(): void {
        const activeUrlStore = useActiveUrlStore();
        const provider = activeUrlStore.getProvider;
         scrapeSuccessful(provider.toLowerCase());
    }
    /**
     * Report failed scrape by provider
     */
    public static scrapeFailed(): void {
        const activeUrlStore = useActiveUrlStore();
        const provider = activeUrlStore.getProvider;
        scrapeFailed(provider.toLowerCase());
    }
    /**
     * Report the search history url selected
     */
    public static urlSearchHistorySelected(): void {
        urlSearchHistorySelected();
    }

    /**
     * Report the sitemap skipped
     */
    public static sitemapSkipped(): void {
        const activeUrlStore = useActiveUrlStore();
        const provider = activeUrlStore.getProvider;
        sitemapSkipped(provider.toLowerCase());
    }

    /**
     * Report the sitemap not found
     */
    public static sitemapNotFound(): void {
        const activeUrlStore = useActiveUrlStore();
        const provider = activeUrlStore.getProvider;
        sitemapNotFound(provider.toLowerCase());
    }
    /**
     * Report the sitemap failed
     */
    public static sitemapFailed(): void {
        const activeUrlStore = useActiveUrlStore();
        const provider = activeUrlStore.getProvider;
        sitemapFailed(provider.toLowerCase());
    }
    /**
     * Report the sitemap generate
     */
    public static sitemapGenerate(): void {
        const activeUrlStore = useActiveUrlStore();
        const provider = activeUrlStore.getProvider;
        sitemapGenerate(provider.toLowerCase());
    }
    /**
     * Report the settings debug chang
     */
    public static settingDebugToggle(): void {
        settingDebug();
    }
    /**
     * Report the settings sitemap toggle
     */
    public static settingSitemapToggle(): void {
        settingSitemapToggle();
    }
    /**
     * Report the settings storage clear
     */
    public static settingStorageClear(): void {
        settingStorageClear();
    }

}
